module.exports = __webpack_public_path__ + "img/file-icon_svg.324a89d3.svg";